export default __webpack_public_path__ + "static/media/dropIcon.e821228b.svg";